<template>
  <v-expansion-panels accordion v-model="showPanel" class="base-shadow">
    <v-expansion-panel expand>
      <v-expansion-panel-header>
        <content-line font-icon icon="screen_share" :text="title" />
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <video-container
          :participant="hostParticipant"
          :localTrack="localVideoTrack"
        />

        <div class="pa-4 pb-1">
          <field-block inline>
            <div class="d-flex">
              <v-checkbox
                v-model="options.video"
                label="Video"
                class="pt-0 mr-5"
              />
              <v-checkbox
                v-model="options.audio"
                label="Audio (tabs only)"
                class="pt-0"
              />
            </div>
          </field-block>
        </div>
        <div class="pa-4">
          <v-btn
            v-if="!context.state.show"
            color="primary"
            @click="shareScreen()"
          >
            Share
          </v-btn>
          <template v-else>
            <v-btn color="primary" @click="update(false)"> Stop & Close </v-btn>

            <v-btn color="primary" @click="shareScreen()" class="ml-3">
              Change
            </v-btn>
          </template>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { eventBus } from '@/lib/events';
import VideoContainer from './VideoContainer';

export default {
  name: 'ActionScreenShareControls',
  components: { VideoContainer },
  props: {
    context: {},
    getSingleParticipant: {},
  },
  data() {
    return {
      showPanel: 0,
      localVideoTrack: null,
      options: {
        video: true,
        audio: true,
      },
    };
  },
  computed: {
    hostParticipant() {
      const { hostId } = this.context.state;
      return this.getSingleParticipant(hostId) || { identity: hostId };
    },
    title() {
      if (this.hostParticipant?.name) {
        return this.hostParticipant.name + "'s " + 'Screen';
      }
      return 'Share Screen';
    },
  },
  methods: {
    update(share = false) {
      this.context.state.show = share;
      this.$emit('update');

      if (!share) {
        this.$emit('close');
        eventBus.trigger('shareScreenVideo', false);
        eventBus.trigger('shareScreenAudio', false);
      }
    },
    shareScreen() {
      let mediaOptions = {
        video: true,
      };

      if (this.options.audio) {
        mediaOptions.audio = {
          autoGainControl: false,
          channelCount: 1,
          echoCancellation: false,
          googAutoGainControl: false,
          latency: 0,
          noiseSuppression: false,
          sampleRate: 48000,
          sampleSize: 16,
          volume: 1.0,
        };
      }

      navigator.mediaDevices
        .getDisplayMedia(mediaOptions)
        .then((stream) => {
          const videoTrack = this.options.video
            ? stream.getVideoTracks()[0]
            : false;
          eventBus.trigger('shareScreenVideo', videoTrack);

          const audioTrack = stream.getAudioTracks()[0];
          eventBus.trigger('shareScreenAudio', audioTrack || false);
        })
        .catch((err) => {
          console.log('share screen error: ', err);
        });
    },

    onShareTracksCreated(newTrack) {
      if (newTrack.kind.includes('video')) {
        this.localVideoTrack = newTrack;
      }

      this.update(true);
    },
  },
  created() {
    eventBus.on('createScreenShareTrack', (newTrack) => {
      this.onShareTracksCreated(newTrack);
    });
  },
};
</script>
